import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../axiosBaseQuery";
import { Response } from "../interfaces";
import { crm } from "../../pages/crm/crmList";

export const crmApi = createApi({
  reducerPath: "crmApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["integration", "api_key", "eventType_list", "event_list"],
  endpoints: (builder) => ({
    getCrmRequest: builder.query<Response<any>, any>({
      query: (credentials) => ({
        url: "integration/getRequest",
        method: "GET",
        data: credentials,
      }),
      providesTags: ["integration"],
    }),
    requestCrm: builder.mutation<
      Response<any>,
      { data: { question: string; answer: string }[] }
    >({
      query: (credentials) => ({
        url: "integration/createRequest",
        method: "POST",
        data: credentials,
      }),
      invalidatesTags: ["integration"],
    }),
    createAPIKey: builder.mutation<Response<any>, any>({
      query: (credentials) => ({
        url: `integration/connect/${credentials.type}`,
        method: "POST",
        data: credentials,
      }),
      invalidatesTags: ["api_key"],
    }),
    getConnectList: builder.query<Response<crm[]>, any>({
      query: (credentials) => ({
        url: "integration/list",
        method: "GET",
        data: credentials,
      }),
      providesTags: ["api_key"],
    }),
    disconnectIntegration: builder.mutation<Response<any>, any>({
      query: (credentials) => ({
        url: `integration/disconnect/${credentials.type}`,
        method: "POST",
        data: credentials,
      }),
      invalidatesTags: ["api_key"],
    }),
    getFieldsList: builder.query<Response<any>, any>({
      query: (credentials) => ({
        url: `integration/CRMfields/${credentials.type}`,
        method: "GET",
        data: credentials,
      }),
    }),
    getStagesList: builder.query<Response<any>, any>({
      query: (credentials) => ({
        url: `integration/CRMstages/${credentials.type}`,
        method: "GET",
        data: credentials,
      }),
    }),
    getEventsTypeList: builder.query<Response<any>, any>({
      query: (credentials) => ({
        url: `integration/CRMevents/${credentials.type}`,
        method: "GET",
        data: credentials,
      }),
    }),
    createEvent: builder.mutation<Response<any>, any>({
      query: (credentials) => ({
        url: `integration/createEvent/${credentials.type}`,
        method: "POST",
        data: credentials,
      }),
      invalidatesTags: ["event_list"],
    }),
    getEventsList: builder.query<Response<any>, any>({
      query: (credentials) => ({
        url: `integration/events/list/${credentials.type}`,
        method: "GET",
        data: credentials,
      }),
      providesTags: ["event_list"]
    }),
    updateEvent: builder.mutation<Response<any>, any>({
      query: (credentials) => ({
        url: `integration/updateEvent/${credentials.event_id}`,
        method: "PATCH",
        data: credentials,
      }),
      invalidatesTags: ["event_list"],
    }),
    updateEventStatus: builder.mutation<Response<any>, any>({
      query: (credentials) => ({
        url: `integration/updateStatus/${credentials.id}`,
        method: "PATCH",
        data: { isActive: credentials.isActive },
      }),
      invalidatesTags: ["event_list"],
    }),
    deleteEvent: builder.mutation<Response<any>, any>({
      query: (credentials) => ({
        url: `integration/deleteEvent/${credentials.id}`,
        method: "DELETE",
        data: credentials,
      }),
      invalidatesTags: ["event_list"],
    }),
  }),
});

export const {
  useRequestCrmMutation, useGetCrmRequestQuery, useCreateAPIKeyMutation,
  useGetConnectListQuery, useDisconnectIntegrationMutation, useGetFieldsListQuery,
  useGetStagesListQuery, useGetEventsTypeListQuery, useCreateEventMutation,
  useGetEventsListQuery, useUpdateEventMutation, useUpdateEventStatusMutation, useDeleteEventMutation } = crmApi;
